var render = function render() {
      var _vm = this,
          _c = _vm._self._c;return _c('permission-manager', { attrs: { "latchkey": "dm" } }, [_c('product-info-verify', { ref: "productInfoVerifyRef", attrs: { "data": {
                        id: _vm.id,
                        promoted_type: _vm.promotedType || '',
                        name: _vm.templateConfig.name
                  }, "isCustom": !_vm.isCommonTemplateCustom, "callback": function callback() {
                        _vm.push();
                  } }, on: { "update": _vm.handleProductUpdate } }, [_c('span', [_vm.$slots.default ? _vm._t("default") : _c('el-button', _vm._b({}, 'el-button', _vm.buttonAttrs, false), [_vm._v("\n        " + _vm._s(_vm.buttonAttrs.text) + "\n      ")])], 2)])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };